"use strict";
Shopify.theme.jsHeader = {
    init: function (e) {
        var a = this;
        (Shopify.theme.jsHeader = $.extend(this, Shopify.theme.getSectionData(e))), (this.$el = $("#header")), (this.$menuToggle = this.$el.find(".header__menu-toggle"));
        var i = $(".announcement-sticky-wrapper").height();
        this.enable_overlay === !0 && isScreenSizeLarge() && this.updateOverlayStyle(this.sectionUnderlayIsImage()),
            this.enable_sticky === !0 && isScreenSizeLarge() && this.enableSticky(i),
            this.header_layout == "centered" || this.header_layout == "search_focus"
                ? this.$menuToggle.on("click", function () {
                      a.showStickyMenu();
                  })
                : this.header_layout == "vertical" &&
                  (e.find(".header-sticky-wrapper").stick_in_parent(), Shopify.theme_settings.announcement_enabled == !0 && Shopify.theme.jsAnnouncementBar.addVerticalHeaderTopMargin(), this.addOffScreenDropdownCheck()),
            $(".mega-menu").length > 0 && Shopify.theme.jsMegaMenu.init(e),
            isScreenSizeLarge() || (this.unload(), Shopify.theme.mobileMenu.init()),
            $(".search-overlay__close").on("click", function () {
                Shopify.theme.jsHeader.hideSearch();
            }),
            $(document).on("click", "[data-show-search-trigger]", function () {
                Shopify.theme.jsHeader.showSearch();
            }),
            (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) &&
                $(".dropdown-click--true .header__link:not(.primary-brand, .primary-logo)").on("click touchstart", function (s) {
                    var n = $(this);
                    Shopify.theme.jsHeader.toggleMenuClick(s, n);
                }),
            this.dropdown_click === !1 &&
                $(".navbar-item").on("mouseleave", function () {
                    Shopify.theme.jsHeader.collapseSubmenu($(this));
                }),
            $(document).on("keydown", "[data-show-search-trigger]", function (s) {
                s.which === 13 && Shopify.theme.jsHeader.showSearch();
            });
    },
    toggleMenuClick: function (e, a) {
        var i = a.parents(".has-dropdown, .has-mega-menu");
        !i.hasClass("is-opened") && i.length !== 0
            ? (e.preventDefault(), $(".has-dropdown, .has-mega-menu").removeClass("is-opened"), $(".mega-menu__section").removeClass("is-active"), i.addClass("is-opened"), i.data("clicked", "true"))
            : ($(".has-dropdown, .has-mega-menu").removeClass("is-opened"), $(".mega-menu__section").removeClass("is-active")),
            $(window).on("click", function (s) {
                $(s.target).closest(".header__link, .navbar-dropdown").length === 0 &&
                    ($(".has-dropdown, .has-mega-menu").removeClass("is-opened"), $(".mega-menu__section").removeClass("is-active"), Shopify.theme.jsHeader.collapseSubmenu($(".navbar-item")));
            });
    },
    collapseSubmenu: function (e) {
        $(e).find(".has-submenu input").prop("checked", !1);
    },
    showStickyMenu: function () {
        this.$menuToggle.toggleClass("is-active"), this.$el.find(".sticky-menu-wrapper").toggleClass("is-visible");
    },
    hideStickyMenu: function () {
        this.$menuToggle.removeClass("is-active"), this.$el.find(".sticky-menu-wrapper").removeClass("is-visible");
    },
    disableSticky: function () {
        var e = $("#header");
        e.unstick(),
            e.removeClass("sticky--enabled"),
            setTimeout(function () {
                e.css("height", "auto");
            }, 250);
    },
    enableSticky: function (e) {
        var a = this,
            i = this.$el;
        i.addClass("sticky--enabled"),
            i
                .sticky({ wrapperClassName: "header-sticky-wrapper", zIndex: 40, topSpacing: e || 0 })
                .on("sticky-start", function () {
                    var s, n;
                    Shopify.theme_settings.header_layout == "centered" && $("[data-ajax-cart-trigger]").removeClass("show-mini-cart"),
                        Shopify.theme.jsHeader.enable_sticky == !0 && Shopify.theme_settings.header_layout != "vertical" && (s = Shopify.theme.jsHeader.getHeaderHeight()),
                        typeof Shopify.theme.jsAnnouncementBar != "undefined" && Shopify.theme.jsAnnouncementBar.enable_sticky == !0 && Shopify.theme_settings.header_layout != "vertical"
                            ? (n = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight())
                            : (n = 0);
                    var r = s + n;
                    i
                        .parent()
                        .parent()
                        .find(".search-overlay")
                        .addClass("sticky-search")
                        .css("top", r + "px"),
                        a.enable_overlay === !0 && a.sectionUnderlayIsImage() === !0 ? (i.parent().addClass("has-overlaid-header"), a.disableOverlayStyle()) : a.enable_overlay === !0 && a.disableOverlayStyle();
                })
                .on("sticky-end", function () {
                    i.parent().parent().find(".search-overlay").removeClass("sticky-search").css("top", "100%"),
                        setTimeout(function () {
                            i.sticky("update");
                        }, 250),
                        a.$el.find(".sticky-menu-wrapper").removeClass("is-visible"),
                        a.$menuToggle.removeClass("is-active"),
                        a.enable_overlay === !0 && a.sectionUnderlayIsImage() === !0 && a.updateOverlayStyle(a.sectionUnderlayIsImage());
                });
    },
    disableOverlayStyle: function () {
        $("[data-enable_overlay]").attr("data-enable_overlay", !1);
    },
    enableOverlayStyle: function () {
        $("[data-enable_overlay]").attr("data-enable_overlay", !0);
    },
    updateOverlayStyle: function (e) {
        $("[data-enable_overlay]").attr("data-enable_overlay", e);
    },
    sectionUnderlayIsImage: function () {
        var e = $("[data-check-for-order=true]").find("[id^=shopify-section]").first();
        return !!(e.hasClass("overlaid-header-option") && $.trim(e.html()).length > 0);
    },
    showSearch: function () {
        $("[data-show-search-trigger]").addClass("is-active"),
            Shopify.theme_settings.search_layout == "overlay"
                ? ($('[data-search-type="' + Shopify.theme_settings.search_layout + '"]').toggleClass("is-opened"), $('.search-form .search__fields input[type="text"]').focus())
                : $.fancybox.open($(".js-search-popup"), {
                      baseClass: "search__lightbox",
                      hash: !1,
                      infobar: !1,
                      toolbar: !1,
                      loop: !0,
                      smallBtn: !0,
                      mobile: { preventCaptionOverlap: !1, toolbar: !1 },
                      beforeClose: function () {
                          $("[data-show-search-trigger]").removeClass("is-active");
                      },
                  });
    },
    hideSearch: function () {
        $("[data-show-search-trigger]").removeClass("is-active"),
            Shopify.theme_settings.search_layout == "overlay"
                ? $('[data-search-type="' + Shopify.theme_settings.search_layout + '"]').removeClass("is-opened")
                : $.fancybox.close($('[data-search-type="' + Shopify.theme_settings.search_layout + '"]'));
    },
    addOffScreenDropdownCheck: function () {
        $(".navbar-item.has-dropdown--vertical").hover(function () {
            var e = $(this),
                a = e.find(".navbar-dropdown");
            a.removeClass("navbar-dropdown--fix-offscreen"), a.is(":off-screen") && a.addClass("navbar-dropdown--fix-offscreen");
        });
    },
    getHeaderHeight: function () {
        var e = $(".header-section").outerHeight() || 0;
        return e;
    },
    unload: function (e) {
        $(".has-overlaid-header").removeClass("has-overlaid-header"),
            $(".search-overlay__close, [data-show-search-trigger]").off(),
            $(".navbar-item").off(),
            $("#header").off(),
            $(".dropdown-click--true .header__link").off(),
            this.$menuToggle.off(),
            this.disableSticky(),
            this.disableOverlayStyle();
    },
};
